import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {BusinessUnitPeriodField, BusinessUnitPeriodFieldClass} from "./BusinessUnitPeriodField";
import BudgetValueInput from "../elements/BudgetValueInput";
import {CurrencySelect} from "../elements/CurrencySelect";
import { withTranslation } from 'react-i18next';
import {
    TYPE_ONE_BUDGET_FOR_ALL,
    TYPE_ONE_BUDGET_PER_ADGROUP,
    TYPE_ONE_BUDGET_PER_CAMPAIGN,
    getTypesData
} from "../business_units/BusinessUnitTypes";
import {HELP_BU_CONFIGURATION_TYPES, LinkToArticle} from "../help_center/LinkToArticle";
import BudgetPartialGoalsConfiguration from "../elements/BudgetPartialGoalsConfiguration";
import {BU_PERIOD_PERIODIC, BU_PERIOD_TEMPORARY} from "../../periods";
import {DatetimeHelper} from "../../utils/DatetimeHelper";
import {BudgetHelper} from "../../utils/BudgetHelper";
import {
    AgencyClientSelect,
    SPECIAL_ITEM_CREATE_AGENCY_CLIENT,
    SPECIAL_ITEM_GO_TO_AGENCY_CLIENTS_ASSIGMENT
} from "../selects/AgencyClientSelect";
import {AddClientModal} from "../agency/AddClientModal";
import CustomSelect from "../elements/CustomSelect";
import {LocalStorage} from "../../utils/LocalStorage";

class AddBusinessUnitFormComponent extends Component {
    constructor(props) {
        super(props);

        const { firstDate, lastDate } = DatetimeHelper.calculateDatesForMonthlyPeriod(1);

        const initialValues = this.props.initialValues || {};

        this.state = {
            clientIsSelectable:this.props.clientId === undefined,
            loading: true,
            creatingBusinessUnit: false,
            channel: 'GOOGLE',
            selectedAccount: null,
            period: initialValues.period || BusinessUnitPeriodFieldClass.defaultSelectedPeriod(),
            budgetValue: initialValues.allocated_budget || null,
            budgetCurrency: initialValues.currency || null, // Del server viene qué currency usar como predeterminada
            canEditCurrency: null,
            businessUnitType: initialValues.type || (this.props.simplifiedOnboardingMode ? TYPE_ONE_BUDGET_FOR_ALL : null),
            budgetPartialGoals: initialValues.raw_budget_partial_goals || [],
            periodFirstDate: firstDate,
            periodLastDate: lastDate,
            clientId: this.props.clientId,
            clientName: this.props.clientName,
            allAgencyClients: null,
            showMissingClientSelectionText: false,
            allowSetFirstDayOnPeriodicBusinessUnits: false
        };

        this.handleSelectedChannelChange = this.handleSelectedChannelChange.bind(this);
        this.handleBusinessUnitTypeChange = this.handleBusinessUnitTypeChange.bind(this);
        this.handlePeriodFieldChange = this.handlePeriodFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.footerButton = this.footerButton.bind(this);
        this.handleSelectedBudgetCurrencyChange = this.handleSelectedBudgetCurrencyChange.bind(this);
        this.handleBudgetValueChange = this.handleBudgetValueChange.bind(this);
        this.handleBudgetPartialGoalsChange = this.handleBudgetPartialGoalsChange.bind(this);
        this.handleAgencyClientChange = this.handleAgencyClientChange.bind(this);
        this.afterSuccessfulAgencyClientCreation = this.afterSuccessfulAgencyClientCreation.bind(this);
    }


    componentDidMount() {
        this.updateCurrency();
    }

    handleAgencyClientChange(agencyClientId, agencyClientName) {
        // Si selecciono "NUEVO CLIENTE"
        if (agencyClientId === SPECIAL_ITEM_CREATE_AGENCY_CLIENT) {
            this.createAgencyClientModal.toggle();
        }

        if (agencyClientId === SPECIAL_ITEM_GO_TO_AGENCY_CLIENTS_ASSIGMENT) {
            this.props.history.push("/user/"+LocalStorage.fetchUserId()+"/module/marketing");
        }

        this.setState({...this.state, clientId: agencyClientId, clientName:agencyClientName, showMissingClientSelectionText: agencyClientId === null});
    }

    handleBudgetPartialGoalsChange(budgetPartialGoals) {
        this.setState({...this.state, budgetPartialGoals: budgetPartialGoals});
    }

    hasClientInformation() {
        return this.state.clientId !== undefined && this.state.clientId !== null;
    }

    renderCreateNewAgencyClientModal() {
        return <AddClientModal
            showButton={false}
            ref={instance => { this.createAgencyClientModal = instance;}}
            onClientAdded={this.afterSuccessfulAgencyClientCreation}/>
    }

    afterSuccessfulAgencyClientCreation(newAgencyClientId, newAgencyClientName) {
        const allAgencyClients = this.state.allAgencyClients;
        const data = {
            'id': newAgencyClientId,
            'name': newAgencyClientName,
            'active': true
        };

        allAgencyClients.push(data);
        this.setState({
            allAgencyClients: allAgencyClients,
            clientId: newAgencyClientId,
            clientName: newAgencyClientName,
        });
    }

    // API

    updateCurrency() {
        if(this.hasClientInformation()) {
            new APIClient(this.getAgencyClientURL()).call('GET').then((response) => {
                if (response.status === 'ERROR') {
                    alert(response.error_message);
                } else if (response.status === 'OK') {
                    this.setState({
                        loading: false,
                        budgetCurrency: response.data['default_currency'],
                        canEditCurrency: response.data['can_edit_currency'],
                        allowSetFirstDayOnPeriodicBusinessUnits: response.data['allow_set_first_day_on_periodic_business_units']
                    })
                }
            });
        } else {
            new APIClient(this.getAgencyDataURL()).call('GET').then((response) => {
                if (response.status === 'ERROR') {
                    alert(response.error_message);
                } else if (response.status === 'OK') {
                    this.setState({
                        loading: false,
                        budgetCurrency: response.general_data['default_currency'],
                        canEditCurrency: response.general_data['can_edit_currency'],
                        allAgencyClients: response.clients,
                        allowSetFirstDayOnPeriodicBusinessUnits: response.general_data['allow_set_first_day_on_periodic_business_units']
                    })
                }
            });
        }


    }

    handleSubmit(event) {
        event.preventDefault();

        if(!this.props.hideClientInput && (this.state.clientId === null || this.state.clientId === undefined)){
            this.setState({showMissingClientSelectionText: true});
            return;
        }

        const submitPayload = this.getSubmitPayload(event.target.businessunitname.value);

        if (this.props.draftMode) {
            this.props.afterDraftSubmit(submitPayload);
            return;
        }

        this.setState({
            creatingBusinessUnit: true
        });

        new APIClient(this.submitUrl()).call('POST', submitPayload).then((data) => {
            this.setState({
                creatingBusinessUnit: false
            });

            if (data.status === 'ERROR') {
                alert(data.error_message);
            } else if (data.status === 'OK') {
                this.props.afterSuccessfulSubmit(data.data.business_unit_id)
            }
        });
    }

    getSubmitPayload(businessUnitName) {
        const payload = {
            'client_id': this.state.clientId,
            // # 202308: Se comenta porque ahora no hace falta seleccionar una cuenta en el primer paso de crear un presupuesto
            // 'ad_account_id': event.target.account.value,
            'name': businessUnitName,
            // 'channel': event.target.campaignChannel.value,
            'currency': this.state.budgetCurrency,
            'allocated_budget': this.state.budgetValue,
            'period': this.state.period,
            'type': this.state.businessUnitType,
            'budget_partial_goals': BudgetHelper.BudgetPartialGoalTranslateToSubmit(this.state.budgetPartialGoals),
        };

        if (this.props.draftMode) {
            payload.raw_budget_partial_goals = this.state.budgetPartialGoals;
        }

        return payload;
    }

    handleBudgetValueChange(newAmount) {
        this.setState({budgetValue: newAmount})
    }

    handleSelectedChannelChange(event) {
        event.preventDefault();
        this.setState({
            channel: event.target.value,
            selectedAccount: null
        });
    }

    handleBusinessUnitTypeChange(newType) {
        this.setState({
            businessUnitType: newType
        });
    }

    handleSelectedBudgetCurrencyChange(newCurrency) {
        this.setState({
            budgetCurrency: newCurrency
        });
    }

    handlePeriodFieldChange(aSelectedPeriod) {
        /*{
          "type": "TEMPORARY",
          "range_definition": {
            "from_date": "09/01/2025",
            "to_date": "09/01/2025"
          }
        }
        {
          "type": "PERIODIC",
          "range_definition": {
            "first_day": "1"
          }
        }
        */

        let periodFirstDate = this.state.periodFirstDate;
        let periodLastDate = this.state.periodLastDate;

        if(aSelectedPeriod !== null) {
            if(aSelectedPeriod["type"] === BU_PERIOD_TEMPORARY) {
                periodFirstDate = aSelectedPeriod["range_definition"]["from_date"] !== "" ? DatetimeHelper.friendlyDDMMYYYYToDate(aSelectedPeriod["range_definition"]["from_date"], "-") : null;
                periodLastDate = aSelectedPeriod["range_definition"]["to_date"] !== "" ? DatetimeHelper.friendlyDDMMYYYYToDate(aSelectedPeriod["range_definition"]["to_date"], "-") : null;
            } else if(aSelectedPeriod["type"] === BU_PERIOD_PERIODIC) {
                const { firstDate, lastDate } = DatetimeHelper.calculateDatesForMonthlyPeriod(aSelectedPeriod["range_definition"]["first_day"]);
                periodFirstDate = firstDate;
                periodLastDate = lastDate;
            }
        }
        this.setState({period: aSelectedPeriod, periodFirstDate: periodFirstDate, periodLastDate: periodLastDate});
    }

    handleAccountChange(accountId, accountName) {
        this.setState({
            selectedAccount: accountId
        })
    }

    footerButton() {
        if (this.state.creatingBusinessUnit) {
            return <Spinner color="positive small"/>
        } else {
            const { t } = this.props;
            return <input type="submit" value={t('client.next_button')} className="btn -submit"/>
        }
    }

    renderFooterStartContent() {
        return this.props.footerStartContent || null;
    }

    renderBudgetCurrencyAndAmount() {
        if (this.state.businessUnitType === TYPE_ONE_BUDGET_FOR_ALL)
            return this.renderOneBudgetForAllInputs();
        else if (this.state.businessUnitType === TYPE_ONE_BUDGET_PER_CAMPAIGN || this.state.businessUnitType === TYPE_ONE_BUDGET_PER_ADGROUP)
            return this.renderOneBudgetPerItemInputs();
    }

    renderOneBudgetPerItemInputs() {
        const { t } = this.props;
        if (!this.state.canEditCurrency)
            return;

        return (
            <div className="row g-3">
                <div className="col-12">
                    <label className="form-label">{t('business_unit.budget_currency')}</label>
                    {this.getCurrencySelectInput()}
                </div>
            </div>);
    }

    getCurrencySelectInput() {
        return <BudgetValueInput
            canEditCurrency={true}
            onlyCurrencySelect={true}
            onCurrencyChange={this.handleSelectedBudgetCurrencyChange}
            onAmountChange={null}
            budgetCurrency={this.state.budgetCurrency}
            budgetAmount={null}
        />;
    }

    renderOneBudgetForAllInputs() {
        const { t } = this.props;
        if (!this.state.canEditCurrency) {
            return (<div className="row g-3">
                <div className="col">
                    <label className="form-label">{t('business_unit.currency')}</label>
                    <CurrencySelect onlyAdAccountCurrencyMode={true}/>
                </div>
                <div className="col">
                    <label className="form-label">{t('business_unit.amount')}</label>
                    {this.getBudgetValueInput(false)}
                </div>
                {this.renderPartialGoals()}
            </div>)
        }

        return (<div className="mb-3">
            <div className="mb-0 pr-0">
                <label className="form-label">{t('business_unit.assigned_budget')}</label>
            </div>
            <div className="row g-3">
                <div className="col">
                    {this.getBudgetValueInput(true)}
                </div>
                <div className={"col"}></div>
            </div>
            {this.renderPartialGoals()}
        </div>)
    }

    renderPartialGoals() {
        return <div key="budget-partial-goals" className="row g-3 mb-3 budget-partial-goals">
            <div className="col-md-12">
                <BudgetPartialGoalsConfiguration
                    className={this.props.simplifiedOnboardingMode ? 'onboarding-budget-partial-goals' : undefined}
                    enabled={(this.state.budgetPartialGoals !== null && this.state.budgetPartialGoals !== undefined && this.state.budgetPartialGoals.length > 0)}
                    budgetPeriodType={this.state.period.type}
                    budgetFromDate={this.state.periodFirstDate}
                    budgetToDate={this.state.periodLastDate}
                    budgetPartialGoals={this.state.budgetPartialGoals}
                    onChange={this.handleBudgetPartialGoalsChange}
                    budgetTotalAmount={this.state.budgetValue}
                />
            </div>
        </div>;
    }

    getBudgetValueInput(showCurrency) {
        return <BudgetValueInput
            hideCurrency={!showCurrency}
            canEditCurrency={this.state.canEditCurrency}
            onCurrencyChange={this.handleSelectedBudgetCurrencyChange}
            onAmountChange={this.handleBudgetValueChange}
            budgetCurrency={this.state.budgetCurrency}
            budgetAmount={this.state.budgetValue}
        />;
    }

    renderTypeSelect() {
        const { t } = this.props;
        const typesData = getTypesData(t);
        const types = Object.keys(typesData);
        const value = this.state.businessUnitType === null ? '' : this.state.businessUnitType;
        const result = [];

        if (this.props.useConfigurationTypeCards) {
            result.push(
                <div key="configuration-type-cards" className="business-unit-type-card-row">
                    {types.map((aType) => {
                        const isSelected = value === aType;
                        return (
                            <button
                                key={aType}
                                type="button"
                                className={`business-unit-type-card${isSelected ? ' -selected' : ''}`}
                                onClick={() => this.handleBusinessUnitTypeChange(aType)}
                                aria-pressed={isSelected}
                            >
                                <strong>{typesData[aType]["Title"]}</strong>
                                <span>{typesData[aType]["Description"]}</span>
                            </button>
                        );
                    })}
                </div>
            );
        } else {
            const options = types.map((a_type) => ({id: a_type, title: typesData[a_type]["Title"], subtitle: typesData[a_type]["Description"]}));
            result.push(<CustomSelect options={options} onSelectOptionChange={this.handleBusinessUnitTypeChange} />);
        }

        if(value === TYPE_ONE_BUDGET_PER_CAMPAIGN)
            result.push(<p className="field-footnote pb-0 mb-0">{t('business_unit.define_campaign_budget_next_step')}</p>);
        if(value === TYPE_ONE_BUDGET_PER_ADGROUP)
            result.push(<p className="field-footnote pb-0 mb-0">{t('business_unit.define_adgroup_budget_next_step')}</p>);
        return result;
    }

    render() {
        const { t } = this.props;
        if (this.state.loading === true) {
            return <div className="box-loader">
                <Spinner color="positive"/>
            </div>
        }

        return [
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <div className="row g-3 mb-3">
                            {!this.props.hideClientInput && (
                                <div className="col-md-6">
                                    <label className="form-label">{t('business_unit.client')}</label>
                                    {this.renderClientInput()}
                                </div>
                            )}
                            <div className={this.props.hideClientInput ? 'col-md-12' : 'col-md-6'}>
                                <label className="form-label">{t('business_unit.control_line_name')}</label>
                                <input name="businessunitname" type="text" required={true} className={"form-control"} defaultValue={this.props.initialValues?.name || ''}/>
                            </div>
                        </div>
                        {!this.props.simplifiedOnboardingMode && (
                            <>
                                <div className="mb-3">
                                    <label className="form-label">{t('business_unit.configuration_type')}<LinkToArticle article={HELP_BU_CONFIGURATION_TYPES}/></label>
                                    {this.renderTypeSelect()}
                                </div>
                                {this.renderBudgetCurrencyAndAmount()}
                                <div className="mb-3 mt-3">
                                    <label className="form-label separator">{t('business_unit.period')}</label>
                                    <BusinessUnitPeriodField onChange={this.handlePeriodFieldChange} hidePeriodicRangeDefinition={!this.state.allowSetFirstDayOnPeriodicBusinessUnits}/>
                                </div>
                            </>
                        )}
                        {this.props.simplifiedOnboardingMode && (
                            <div className="onboarding-control-line-budget">
                                {this.renderBudgetCurrencyAndAmount()}
                            </div>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.renderFooterStartContent()}
                    {this.footerButton()}
                </ModalFooter>
            </form>,
            this.renderCreateNewAgencyClientModal()];

    }

    renderClientInput() {
        if(!this.state.clientIsSelectable)
            return <input name="client" type="text" value={this.state.clientName} readOnly={true} className="form-control"/>;

        return <AgencyClientSelect allAgencyClients={this.state.allAgencyClients}
                                   onAgencyClientChange={this.handleAgencyClientChange}
                                   canCreateNewAgencyClient={true}
                                   selectedAgencyClient={this.state.clientId}
                                   showFormValidationTexts={this.state.showMissingClientSelectionText}
        />
    }

    // URLS

    getAgencyClientURL(channel) {
        return `${API_URL}client/${this.state.clientId}/basic-data`
    }

    getAgencyDataURL() {
        return `${API_URL}get-agency-data`
    }

    submitUrl() {
        return API_URL + 'business-unit/add';
    }
}

export const AddBusinessUnitForm = withTranslation()(AddBusinessUnitFormComponent);
